export const Accordion = () => {
    const faqSection = document.querySelectorAll('.faq-section');

    if (faqSection.length > 0) {
        faqSection.forEach(section => {
            const accordionItems = section.querySelectorAll('.faq-section__items');

            accordionItems.forEach(item => {
                const content = item.querySelector('.faq-section__collapse');
                const button = item.querySelector('.faq-section__header button');

                button.addEventListener('click', () => {
                    item.classList.toggle('opened');
                    if (button.getAttribute('aria-expanded') === "false") {
                        content.style.maxHeight = content.scrollHeight + 150 + "px";
                        button.setAttribute('aria-expanded', 'true')
                    } else {
                        content.style.maxHeight = null;
                        button.setAttribute('aria-expanded', 'false')
                    }

                });

            });

        });
    }


}

export const SwitchableTabs = (config = {
    sections: null,
    content: null,
    buttons: null
}) => {

    if (!config.sections || !config.content || !config.buttons) {
        return;
    }

    const sections = document.querySelectorAll(config.sections);

    if (sections.length > 0) {
        sections.forEach(section => {
            const content = section.querySelectorAll(config.content);
            const buttons = section.querySelectorAll(config.buttons);

            buttons.forEach(button => {
                button.addEventListener('click', (e) => {

                    const target = button.dataset.target;

                    content.forEach(item => {
                        item.classList.remove('active');
                    });

                    document.querySelector(`#${target}`).classList.add('active');


                    buttons.forEach(btn => {
                        btn.classList.remove('active');
                    });

                    button.classList.add('active');
                });
            });


        });
    }
};